import { debounce } from "lodash";
import { useEvent } from "./event";
import { postGameMessage } from "../components/Screen/ScreenInteractions";

export type ResizeEvent = 'rs';

export interface IElDimensions {
    h: number;
    w: number;
}

    export const postScreenSizeMessage = () => {
        const screenEl = document.getElementById('screen');

        if (!screenEl) return;

        postGameMessage({
            e: 'rs',
            s: {
                h: screenEl.clientHeight,
                w: screenEl.clientWidth
            }
        })
    };

    export const useScreenSize = () => {
        useEvent('resize', debounce(postScreenSizeMessage, 200));
    }

